import { payments, recharge, transactionRecord, axiosOnline } from '../../api/apiIndex'
import { Message } from 'element-ui';
import i18n from "../../utils/lang/index.js";
import Router from "../../router/index.js"

export default {
  state: {
    post_data: {
      money: null,
      payment_desc: "",
      payment_id: "",
      payment_type: ""
    },
    paymentList: [],
    rechargeRecordList: {},
    rechargeRecordDetails: {}
  },
  getters: {},
  mutations: {
    setRecharge(state, params){
      state.post_data = params;
    },
    setPaymentList(state, data){
      state.paymentList = data;
    },
    setRechargeRecordList(state, data){
      state.rechargeRecordList = data;
    },
    setRechargeRecordDetails(state, data){
      state.rechargeRecordDetails = data;
    },
  },
  actions: {
    setRecharge(context, params){
      recharge(params).then(res => {
        context.commit("setRecharge", res.data);
        if (res.status === "success") {
          if ("pay_url" in res) {
            window.location.href = res.pay_url;
            // Router.push({ path: '/recharge-payment', query: { payUrl: res.pay_url }})
          }
          Message.success(res.message);
        } else {
          Message.error(res.message);
        }
      }).catch(err => {
        Message.error(err.response.data.message);
      })
    },
    getPaymentList(context){
      axiosOnline({ lang: context.rootState.lang.language.value, domain: context.rootState.auth.userInfo.site }).then(res => {
        context.commit("setPaymentList", res.data);
      })
      .catch((err) => {
        console.log("HELLO", err.response.data.error == 'Unauthenticated.');
        if (err.response.data.error == 'Unauthenticated.') {
          Message.error(i18n.t('当前未登录,请先登录'));
        }
      });
    },
    getRechargeRecordList(context, data){
      transactionRecord(data).then(res => {
        context.commit("setRechargeRecordList", res.data);
        context.commit("setRechargeRecordDetails", res);
      })
      .catch((err) => {
        Message.error(err.message);
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/recharge.js